/** Utilitários para gravar e restaurar a posição de rolagem vertical das abas. */

/** Retorna o elemento que realmente rola o conteúdo do layout. */
function container(): HTMLElement | null {
  if (typeof document === "undefined") return null;
  const elemento = document.querySelector<HTMLElement>("[data-scroll-container], main");
  if (elemento && elemento.scrollHeight > elemento.clientHeight + 1) return elemento;
  return elemento;
}

/** Lê a posição de rolagem atual. */
export function posicaoRolagem(): number {
  const el = container();
  if (el && el.scrollTop > 0) return el.scrollTop;
  if (typeof window !== "undefined" && window.scrollY > 0) return window.scrollY;
  return el?.scrollTop ?? 0;
}

/** Restaura a posição de rolagem, repetindo por alguns quadros até o conteúdo renderizar. */
export function restaurarRolagem(y: number, tentativas = 12) {
  if (typeof window === "undefined" || y <= 0) return;
  let n = 0;
  const aplicar = () => {
    const el = container();
    if (el) el.scrollTop = y;
    window.scrollTo(0, y);
    if (++n < tentativas) requestAnimationFrame(aplicar);
  };
  requestAnimationFrame(aplicar);
}

import { getSessionItem, setSessionItem, removeSessionItem } from "@/lib/storage-safe";

/** Grava a posição atual em sessionStorage sob uma chave. */
export function gravarRolagem(chave: string) {
  try {
    setSessionItem(chave, String(posicaoRolagem()));
  } catch {
    /* ignora */
  }
}

/** Recupera e limpa a posição gravada, restaurando-a na tela. */
export function consumirRolagem(chave: string) {
  try {
    const v = getSessionItem(chave);
    if (!v) return;
    removeSessionItem(chave);
    restaurarRolagem(Number(v));
  } catch {
    /* ignora */
  }
}
